import BaseApi from './baseApi';

export interface SchoolThemeResponse {
  logo_url: string | null;
  login_image_url: string | null;
  theme_id: number;
  school_name: string;
  domain: string;
}

class SchoolApi extends BaseApi {
  constructor() {
    const baseUrl = (process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000').replace(/\/$/, '');
    super(baseUrl);
  }

  /**
   * Get school theme data including permanent logo URL
   */
  async getSchoolAssets(): Promise<SchoolThemeResponse | null> {
    // If SCHOOL is base, return Aralin defaults immediately
    const school = process.env.NEXT_PUBLIC_SCHOOL || 'base';
    if (school === 'base' || school === 'null' || school === '') {
      return {
        logo_url: '/logo.png',  // Default Aralin logo
        login_image_url: null,
        theme_id: 0,
        school_name: 'Aralin',
        domain: 'localhost'
      };
    }

    try {
      const data = await this.get<SchoolThemeResponse>(`/theme/`);
      return data;
    } catch (error) {
      console.error('Failed to fetch school theme:', error);
      return {
        logo_url: '/logo.png',  // Default Aralin logo
        login_image_url: null,
        theme_id: 0,
        school_name: 'Aralin',
        domain: 'localhost'
      };
    }
  }
}

// Create and export a singleton instance
export const schoolApi = new SchoolApi();